import * as React from 'react';

import {
  EntryRacer,
  EntryRacerNote,
  ReleaseStatus,
} from '@/lib/apollo/types/gen/graphql';

import BracketNumberData from '../BracketNumberData';
import RacerNote from '../Partials/RacerNote';
import {
  BicycleNumberData,
  BorderData,
  BorderHeader,
  RacerNameHeader,
  TableRow,
} from '../style';
import { NameWrapper, Table } from './style';

interface OverlayTableProps {
  entryRacers: EntryRacer[];
  entryRacerNoteList?: EntryRacerNote[];
  showEntryRacerNoteModal?: (entryRacer: EntryRacer) => void;
}

const OverlayTable: React.FC<OverlayTableProps> = ({
  entryRacers,
  entryRacerNoteList,
  showEntryRacerNoteModal,
}) => {
  return (
    <Table>
      <thead>
        <tr>
          <BorderHeader width="20px">枠</BorderHeader>
          <BorderHeader width="20px">車</BorderHeader>
          <RacerNameHeader width="80px">選手名</RacerNameHeader>
        </tr>
      </thead>
      <tbody>
        {entryRacers &&
          entryRacers.map((er, eri) => (
            <TableRow
              key={eri}
              bicycleNum={er.bicycleNum}
              disabled={er.releaseStatus !== ReleaseStatus.Released}
            >
              <BracketNumberData
                bracketNum={er.bracketNum}
                entryRacers={entryRacers}
                index={eri}
                isRecentResult={false}
              />
              <BicycleNumberData
                bicycleNum={er.bicycleNum}
                disabled={er.releaseStatus !== ReleaseStatus.Released}
              >
                {er.bicycleNum}
              </BicycleNumberData>
              <BorderData>
                <NameWrapper>
                  <span>{er.shortName}</span>
                  <RacerNote
                    entryRacer={er}
                    entryRacerNoteList={entryRacerNoteList}
                    showEntryRacerNoteModal={showEntryRacerNoteModal}
                  />
                </NameWrapper>
              </BorderData>
            </TableRow>
          ))}
      </tbody>
    </Table>
  );
};

export default OverlayTable;
